import crud from './_crud'
import { callApi } from 'utils/api'
import { showErrorMessage, showSuccessMessage } from 'utils/messages'

const actions = crud(
	'transport_figure',
	'la figura de transporte',
	'las figuras de transporte'
)

const getTransportFigureData = (options) => {
	return async (dispatch, getState) => {
		const state = getState()
		const res = await callApi(
			`/transport_figure/utils/get_transport_figure_data`,
			{
				method: 'GET',
				headers: {
					Authorization: state.app.user.token,
				},
			}
		)
		dispatch({
			type: 'LOAD_TRANSPORT_FIGURES',
			response: res.body,
		})
		return res.body
	}
}

const createTransportFigure = (item) => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(`/transport_figure/create_transport_figure`, {
			method: 'POST',
			headers: {
				Authorization: state.app.user.token,
			},
			body: JSON.stringify(item),

			successMessage: 'Se agregó la figura de transporte correctamente.',
		})

		dispatch({
			type: 'ADD_TRANSPORT_FIGURE',
			response: res.body,
		})
		return res.body
	}
}

const updateTransportFigure = (item) => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(`/transport_figure/update_transport_figure`, {
			method: 'POST',
			headers: {
				Authorization: state.app.user.token,
			},
			body: JSON.stringify(item),

			successMessage: 'Se actualizó la figura de transporte correctamente.',
		})

		dispatch({
			type: 'UPDATE_TRANSPORT_FIGURE',
			response: res.body?.id ? res.body : item,
		})
		return res.body
	}
}

const getTransportFigureById = (id) => {
	return async (dispatch, getState) => {
		const state = getState()
		const res = await callApi(
			`/transport_figure/utils/get_transport_figure_data/${id}`,
			{
				method: 'GET',
				headers: {
					Authorization: state.app.user.token,
				},
			}
		)
		dispatch({
			type: 'LOAD_TRANSPORT_FIGURE',
			response: res.body,
		})
		return res.body
	}
}

const deleteTransportFigure = (item) => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(
			`/transport_figure/utils/delete_transport_figure`,
			{
				method: 'DELETE',
				headers: {
					Authorization: state.app.user.token,
				},
				body: JSON.stringify(item),

				successMessage: 'Se eliminó la figura de transporte correctamente.',
			}
		)

		dispatch({
			type: 'DELETE_TRANSPORT_FIGURE',
			response: res.body?.id ? res.body : item,
		})
		return res.body
	}
}

export default {
	...actions,
	getTransportFigureData,
	createTransportFigure,
	updateTransportFigure,
	getTransportFigureById,
	deleteTransportFigure,
}
